import axios from 'axios';
import { createSignedGetRequest } from 'utils/createSignedRequestsHelpers';

export const getEmployeeConfigurationsInBusiness = async (businessId) => {
  const apiPath = `business/${businessId}/employee-configurations`;

  const signedRequest = await createSignedGetRequest({ apiPath });

  const response = await axios(signedRequest);

  return response.data;
};
